import React, { useMemo } from 'react';
import { CalendarEventType } from '@features/Calendar/constants';
import Visit from './Visit';
import TimeOff from './TimeOff';
import Holiday from './Holiday';
import GenericEvent from './GenericEvent';
function CalendarEvent(params) {
    const content = useMemo(() => {
        var _a, _b, _c, _d;
        switch ((_c = (_b = (_a = params.fcProps) === null || _a === void 0 ? void 0 : _a.event) === null || _b === void 0 ? void 0 : _b.extendedProps) === null || _c === void 0 ? void 0 : _c.type) {
            case CalendarEventType.Visit:
                // extendedProps.data is a lightweight CalendarVisit (id, title, assignee, status only).
                // Full visit details are loaded on-demand via useVisitDetails when the modal opens —
                // no full visit data is embedded here to keep the calendar payload small.
                return (React.createElement(Visit, { visit: params.fcProps.event.extendedProps.data, highlightStatus: (_d = params.fcProps.event.extendedProps.highlightingStatus) !== null && _d !== void 0 ? _d : false }));
            case CalendarEventType.Timeoff:
                return React.createElement(TimeOff, { timeOff: params.fcProps.event.extendedProps.data });
            case CalendarEventType.Holiday:
                return React.createElement(Holiday, { holiday: params.fcProps.event.extendedProps.data });
            case CalendarEventType.Generic_event:
                return React.createElement(GenericEvent, { genericEvent: params.fcProps.event.extendedProps.data });
            default:
                return null;
        }
    }, [params.fcProps.event.extendedProps]);
    return content;
}
export default React.memo(CalendarEvent, (prev, next) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    const a = prev.fcProps.event.extendedProps;
    const b = next.fcProps.event.extendedProps;
    return (a.key === b.key &&
        a.highlightingStatus === b.highlightingStatus &&
        a.type === b.type &&
        ((_b = (_a = a.data) === null || _a === void 0 ? void 0 : _a.assignee) === null || _b === void 0 ? void 0 : _b.key) === ((_d = (_c = b.data) === null || _c === void 0 ? void 0 : _c.assignee) === null || _d === void 0 ? void 0 : _d.key) &&
        ((_f = (_e = a.data) === null || _e === void 0 ? void 0 : _e.status) === null || _f === void 0 ? void 0 : _f.key) === ((_h = (_g = b.data) === null || _g === void 0 ? void 0 : _g.status) === null || _h === void 0 ? void 0 : _h.key) &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ((_l = (_k = (_j = a.data) === null || _j === void 0 ? void 0 : _j.start) === null || _k === void 0 ? void 0 : _k.valueOf) === null || _l === void 0 ? void 0 : _l.call(_k)) === ((_p = (_o = (_m = b.data) === null || _m === void 0 ? void 0 : _m.start) === null || _o === void 0 ? void 0 : _o.valueOf) === null || _p === void 0 ? void 0 : _p.call(_o)) &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ((_s = (_r = (_q = a.data) === null || _q === void 0 ? void 0 : _q.start) === null || _r === void 0 ? void 0 : _r.utcOffset) === null || _s === void 0 ? void 0 : _s.call(_r)) === ((_v = (_u = (_t = b.data) === null || _t === void 0 ? void 0 : _t.start) === null || _u === void 0 ? void 0 : _u.utcOffset) === null || _v === void 0 ? void 0 : _v.call(_u)));
});
